import type { TerritoryCode } from '~/lib/territories/territories';

import type {
  BenchmarkDataType,
  BenchmarksDataResponse,
  CampaignBenchmark,
} from './types';
import { toTitleCase } from './utils';

const formatBenchmarkData = (data: BenchmarkDataType): CampaignBenchmark => {
  return {
    id: data.id,
    market: data.country_code,
    partyIds: data.artist_id ? [data.artist_id] : [],
    objective: data.objective,
    platform: data.social_platform,
    type: data.data_level,
    CPM: data.cpm,
    CPV: data.cpv,
    CPC: data.cpc,
    VTR: data.vtr,
    CTR: data.ctr,
    engagementRate: data.engagement_rate,
  };
};

export const getBenchmarks = async ({
  partyId,
  objective = 'Awareness',
  territoryCodes,
  platforms,
}: {
  partyId?: string;
  objective?: string;
  territoryCodes?: TerritoryCode[];
  platforms?: string[];
}) => {
  if (!partyId) {
    throw new Error('Party ID is required');
  }

  try {
    const params = new URLSearchParams();

    params.set('artist_id', partyId);
    if (objective) {
      params.set('objective', toTitleCase(objective));
    }
    if (territoryCodes && territoryCodes.length > 0) {
      params.set('country_code', territoryCodes.join(','));
    }
    if (platforms && platforms.length > 0) {
      params.set('platform', platforms.map(toTitleCase).join(','));
    }

    const response = await fetch(
      `/api/mixone/api/v1/campaign_planner/benchmarks?${params.toString()}`,
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch benchmarks: ${response.statusText}`);
    }

    const data: BenchmarksDataResponse = await response.json();
    return data.data?.length ? data.data.map(formatBenchmarkData) : [];
  } catch (error) {
    console.error('Error fetching benchmarks:', error);
    throw error;
  }
};
